import { Link } from 'react-router'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { cn } from '@/utils'
import { useQuickActionsWidget } from './QuickActionsWidget.logic'

export function QuickActionsWidget() {
  const { t, actions } = useQuickActionsWidget()

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('quickActions')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {actions.map((action) => (
            <Link
              key={action.labelKey}
              to={action.to}
              className="flex flex-col items-center gap-2 rounded-lg border p-3 transition-colors hover:bg-muted/50"
            >
              <div className={cn('rounded-lg p-2', action.colorClass)}>
                <action.icon className="size-5" />
              </div>
              <span className="text-sm font-medium">{action.label}</span>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
